<template>
  <div class="idea-challenges">
    <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
    <transition name="fade">
      <div v-if="contentReady && contentLoadError === ''">
        <ContentHeader name="Idea Challenges"></ContentHeader>
        <section v-if="activeIdeaChallenges.length > 0">
          <b-card-group deck>
            <IdeaChallengeSnippet
              v-for="ideaChallengeA of activeIdeaChallenges"
              v-bind:key="ideaChallengeA.id"
              :idea-challenge="ideaChallengeA">
            </IdeaChallengeSnippet>
          </b-card-group>
        </section>
        <section v-if="activeIdeaChallenges.length === 0">
          <h5 class="text-black-50 mb-4 text-center">
            <em>There are no active idea challenges at present.<br>
              Check this space again sometime soon.
            </em>
          </h5>
        </section>
        <h3 class="text-white-50 bg-secondary p-3 mb-4">Expired challenges</h3>
        <section v-if="inActiveIdeaChallenges.length > 0">
          <div class="card-columns">
            <IdeaChallengeSnippet
              v-for="ideaChallengeIA of inActiveIdeaChallenges"
              v-bind:key="ideaChallengeIA.id"
              :idea-challenge="ideaChallengeIA"
              excerpt="true">
            </IdeaChallengeSnippet>
        </div>
        </section>
        <section v-if="inActiveIdeaChallenges.length === 0">
          <!--h5 class="text-black-50 mb-4 text-center">
            <em>There are no expired idea challenges.
            </em>
          </h5-->
        </section>
      </div>
    </transition>
  </div>
</template>

<script>
import ContentHeader from '@/components/ContentHeader'
import IdeaChallengeSnippet from '@/components/IdeaChallengeSnippet'
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import PreContentHeader from '@/components/PreContentHeader'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      activeIdeaChallenges: [],
      inActiveIdeaChallenges: [],
      errors: [],
      contentReady: false,
      contentLoadError: ''
    }
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      'getUserCommunityIDstring'
    ])
  },
  components: {
    PreContentHeader,
    ContentHeader,
    IdeaChallengeSnippet
  },
  created () {
    this.loadContent()
  },
  methods: {
    getAPiCallString: function () {
      if (!this.$store.getters.isAdmin && this.getUserCommunityIDstring !== undefined) {
        return 'community_categories=' + this.getUserCommunityIDstring
      } else {
        return ''
      }
    },
    loadContent: function () {
      document.title = this.$route.name + ' - ThinkTank'
      WordpressRestAPI.getViewContent('idea_challenge?_embed&idea_chalenge_category_exclude=10&' + this.getAPiCallString() + '&per_page=100')
        .then(response => {
          this.activeIdeaChallenges = response.data.filter(x => !x.idea_chalenge_category.includes(30))
          this.inActiveIdeaChallenges = response.data.filter(x => x.idea_chalenge_category.includes(30))
          this.contentReady = true
        })
        .catch(e => {
          this.contentLoadError = 'Oops! We had a problem with loading the Idea challenges. Please try again later.'
          console.error(e)
          this.contentReady = true
        })
    }
  },
  watch: {
    getUserCommunityIDstring (newDetails, oldDetails) {
      if (!this.$store.getters.isAdmin) {
        this.loadContent()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/routes/IdeaChallenges.vue